@use '@/styles/variables' as *;

// ─── Container ────────────────────────────────────────────────────────────────

.nav {
  position: fixed;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.625rem;
  z-index: $z-header - 1;

  @media (max-width: #{$breakpoint-sm}) {
    display: none;
  }
}

// ─── Track with connecting line ───────────────────────────────────────────────

.track {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  // Vertical line connecting all dots
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 10px;
    bottom: 10px;
    width: 1px;
    background: linear-gradient(to bottom, transparent, var(--border) 20%, var(--border) 80%, transparent);
  }
}

// ─── Dot link ─────────────────────────────────────────────────────────────────

.dotLink {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  // Generous hit area without affecting layout
  width: 20px;
  height: 20px;
  text-decoration: none;
  z-index: 1;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--border);
  transition:
    width 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    background-color 0.35s ease,
    box-shadow 0.35s ease;
  flex-shrink: 0;
}

.dotLink:hover .dot {
  background: var(--muted-foreground);
}

.dotLink.active .dot {
  width: 10px;
  height: 10px;
  background: var(--forest);
  box-shadow: 0 0 0 3px color-mix(in oklch, var(--forest) 22%, transparent);
}

// ─── Label ────────────────────────────────────────────────────────────────────

.label {
  position: absolute;
  right: calc(100% + 10px);
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: var(--muted-foreground);
  white-space: nowrap;
  opacity: 0;
  transform: translateX(6px);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    color 0.2s ease;
  pointer-events: none;
}

.dotLink:hover .label {
  opacity: 1;
  transform: translateX(0);
}

.dotLink.active .label {
  color: var(--foreground);
  font-weight: 600;

  // Only always-visible on large screens; on medium screens hover reveals it
  @media (min-width: #{$breakpoint-lg}) {
    opacity: 1;
    transform: translateX(0);
  }
}

// ─── Scroll percentage ────────────────────────────────────────────────────────

.percent {
  font-size: 0.6rem;
  font-weight: 600;
  color: var(--muted-foreground);
  letter-spacing: 0.06em;
  font-variant-numeric: tabular-nums;
  opacity: 0.55;
}

// ─── Reduced motion ───────────────────────────────────────────────────────────

@media (prefers-reduced-motion: reduce) {
  .dot,
  .label {
    transition: none;
  }
}
